import { getLayoutMaxWidth } from '@/_shared/tools/layout.js';
import { makeStyles, tokens } from '@fluentui/react-components';
import { containerQueryMin, mediaQueryMax, px } from '@this/app-shared/dist/tools/styles.js';

export const COLUMN_WIDTH = 456;
export const GAP = 20;

export const useSharedStyles = makeStyles({
    padding: {
        padding: tokens.spacingHorizontalM,
    },
    root: {
        display: 'grid',
        height: '100%',
        overflow: 'auto',
    },
    container: {
        ...getLayoutMaxWidth(true),
        containerType: 'inline-size',
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${px(COLUMN_WIDTH)}, 1fr))`,
        gap: tokens.spacingVerticalXL,
        padding: tokens.spacingHorizontalXXL,
        height: 'max-content',
        gridAutoFlow: 'dense',

        [mediaQueryMax(px(COLUMN_WIDTH * 2 + GAP))]: {
            gridTemplateColumns: '1fr',
        },
    },
    oneColumn: {
        gridColumn: 'span 1',
    },
    twoColumns: {
        gridColumn: 'span 1',

        [containerQueryMin(px(COLUMN_WIDTH * 2 + GAP))]: {
            gridColumn: 'span 2',
        },
    },
    threeColumns: {
        gridColumn: '1 / -1',
    },
    oneRow: {
        minHeight: px(256),
    },
    twoRows: {
        minHeight: px(512),
    },
    threeRows: {
        minHeight: px(768),
    },
});
